import { Box, Typography, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Button } from "./Button";
import { useAppUrl } from "../hooks/useAppUrl";

const HeroContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  maxWidth: "1200px",
  margin: "0 auto",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    alignItems: "center",
    gap: "40px",
  },
}));

const TitleSection = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  width: "544px",
  alignItems: "flex-start",
  [theme.breakpoints.down("md")]: {
    width: "100%",
    alignItems: "center",
  },
}));

const TextContent = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
  width: "100%",
  [theme.breakpoints.down("md")]: {
    textAlign: "center",
  },
}));

const MainTitle = styled(Typography)(({ theme }) => ({
  color: "var(--text-primary)",
  "& .highlight": {
    color: "var(--brand-primary)",
  },
  [theme.breakpoints.down("md")]: {
    fontSize: "var(--heading-h1-mobile-font-size)",
    lineHeight: "var(--heading-h1-mobile-line-height)",
  },
}));

const Subtitle = styled(Typography)(({ theme }) => ({
  color: "var(--text-secondary)",
  [theme.breakpoints.down("md")]: {
    fontSize: "var(--paragraph-p1-mobile-font-size)",
    lineHeight: "var(--paragraph-p1-mobile-line-height)",
  },
}));

const ImageSection = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "557px",
  height: "575px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  [theme.breakpoints.down("md")]: {
    width: "100%",
    maxWidth: "400px",
    height: "auto",
    aspectRatio: "1 / 1",
  },
}));

const HeroImage = styled("img")(({ theme }) => ({
  width: "100%",
  height: "100%",
  objectFit: "contain",
  [theme.breakpoints.down("md")]: {
    height: "auto",
  },
}));

export const HeroSection = () => {
  const { t } = useTranslation();
  const appUrl = useAppUrl();

  return (
    <HeroContainer>
      <TitleSection>
        <TextContent>
          <MainTitle variant="h1">
            <span className="highlight">{t("hero.titleHighlight")}</span>{" "}
            {t("hero.titleRest")}
          </MainTitle>
          <Subtitle variant="body1">
            {t("hero.subtitle")}
          </Subtitle>
        </TextContent>
        <Button 
          variant="primary" 
          size="s"
          onClick={() => window.open(appUrl, '_blank', 'noopener,noreferrer')}
        >
          {t("hero.cta")}
        </Button>
      </TitleSection>

      <ImageSection>
        <HeroImage src="/assets/hero-img.webp" alt="Selfmade ID Hero" />
      </ImageSection>
    </HeroContainer>
  );
};
